import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import reportsSettingsApi from '@custom/rtk-apis/report/reportsSettings';
import { ReportsSettingsState } from '@custom/Settings/types';

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const reportsSettingsSlice = createSlice({
  name: 'reportsSettingsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(reportsSettingsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportsSettingsApi.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(reportsSettingsApi.rejected, (state, {payload}) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default reportsSettingsSlice.reducer;
